import { useTranslation } from "react-i18next";
import { LocalizedLink as Link } from "@/components/routing/LocalizedLink";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, CheckCircle2, Sparkles, Zap } from "lucide-react";

export function BusinessValidatorWidget() {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "en").startsWith("fr") ? "fr" : "en";

  const T = lang === "fr"
    ? {
        eyebrow: "Nouveau · Outil gratuit",
        h: "Validez votre idée d'entreprise en 90 secondes",
        sub: "Score IA, forces, risques et plan d'action — gratuit, sans inscription.",
        b1: "Évaluation IA en 4 dimensions",
        b2: "Rapport actionnable par email",
        b3: "Aucune carte requise",
        cta: "Lancer le validateur",
      }
    : {
        eyebrow: "New · Free tool",
        h: "Validate your business idea in 90 seconds",
        sub: "AI score, strengths, risks, and a 3-step action plan — free, no signup required.",
        b1: "AI grading across 4 dimensions",
        b2: "Actionable report by email",
        b3: "No credit card required",
        cta: "Run the validator",
      };

  return (
    <section className="container relative py-12 md:py-16">
      <Card className="overflow-hidden border-primary/30 bg-gradient-to-br from-primary/10 via-background to-background">
        <CardContent className="grid gap-6 p-6 md:grid-cols-[1.4fr_1fr] md:gap-10 md:p-10">
          <div>
            <Badge variant="outline" className="mb-3"><Sparkles className="mr-1 h-3 w-3" /> {T.eyebrow}</Badge>
            <h2 className="font-display text-3xl font-extrabold tracking-tight md:text-4xl">{T.h}</h2>
            <p className="mt-3 max-w-xl text-muted-foreground">{T.sub}</p>
            <ul className="mt-5 space-y-2 text-sm">
              <li className="flex items-center gap-2"><CheckCircle2 className="h-4 w-4 text-primary" /> {T.b1}</li>
              <li className="flex items-center gap-2"><CheckCircle2 className="h-4 w-4 text-primary" /> {T.b2}</li>
              <li className="flex items-center gap-2"><CheckCircle2 className="h-4 w-4 text-primary" /> {T.b3}</li>
            </ul>
          </div>
          <div className="flex items-center justify-center md:justify-end">
            <div className="flex w-full flex-col items-stretch gap-3 sm:max-w-xs">
              <div className="rounded-2xl border border-border bg-background/80 p-5 text-center shadow-sm backdrop-blur">
                <Zap className="mx-auto mb-2 h-7 w-7 text-primary" />
                <div className="font-display text-3xl font-extrabold">90<span className="text-base font-bold text-muted-foreground">s</span></div>
                <div className="text-xs uppercase tracking-wider text-muted-foreground">{lang === "fr" ? "Temps moyen" : "Avg. time"}</div>
              </div>
              <Button asChild variant="brand" size="lg" className="w-full">
                <Link to="/business-validator">{T.cta} <ArrowRight className="ml-2 h-4 w-4" /></Link>
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </section>
  );
}